<!-- <span class="head">Product Health Index</span> -->

<div class="box" [ngClass]="config?.layout || 'columns'">

  <!-- Segment -->
  <div>
    <mat-form-field>
      <mat-label style="color: black;  font-size: 1.1rem">Segment</mat-label>
      <mat-select [(ngModel)]="selectedMarket" multiple>
        <mat-option>
          <ngx-mat-select-search
            [formControl]="marketSearchCtrl"
            placeholderLabel="Search..."
            noEntriesFoundLabel="No matching options">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option (click)="toggleAllSelection('Market')" [value]="'All'">
          All
        </mat-option>
        <mat-option *ngFor="let item of filteredMarket" [value]="item" (click)="togglePerOneSelection('Market')">
          {{ item }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Platform -->
  <div>
    <mat-form-field>
      <mat-label style="color: black; font-size: 1.1rem">Platform</mat-label>
      <mat-select [(ngModel)]="selectedEngine" multiple>
        <mat-option>
          <ngx-mat-select-search
            [formControl]="engineSearchCtrl"
            placeholderLabel="Search..."
            noEntriesFoundLabel="No matching options">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option (click)="toggleAllSelection('Engine')" [value]="'All'">All</mat-option>
        <mat-option *ngFor="let item of filteredEngines" [value]="item" (click)="togglePerOneSelection('Engine')">
          {{ item }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Year -->
<div *ngIf="year_filter">
  <mat-form-field>
    <mat-label style="color: black; font-size: 1.1rem">Year</mat-label>
    <mat-select [(ngModel)]="selectedYear" multiple>
      <mat-option>
        <ngx-mat-select-search
          [formControl]="yearSearchCtrl"
          placeholderLabel="Search..."
          noEntriesFoundLabel="No matching options">
        </ngx-mat-select-search>
      </mat-option>
      <!-- keep your All behavior -->
      <mat-option (click)="toggleAllSelection('Year')" [value]="'All'">
        All
      </mat-option>

      <!-- bind years coming from API -->
      <mat-option
        *ngFor="let y of filteredYears"
        [value]="y"
        (click)="togglePerOneSelection('Year')"
      >
        {{ y }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>


  <!-- Reset -->
  <!--
  <div (click)="resetSelection()" class="info-icon" style="display: flex; align-items: center; cursor: pointer">
    <mat-icon>filter_alt</mat-icon><span>Reset Filter</span>
  </div>
  -->

</div>
